import React from "react";
import Footer from "../Footer";
import Header from "../Header";

// Components

export const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};
